import React from 'react'
import PropTypes from 'prop-types'
import { StyledButton as Button } from '../../../common/Button'
import { StyledFormElement as FormElement } from '../../../common/FormElement'
import Text from 'common/components/Text'
import Menu from '../../../common/Menu'
import SectionOptionsContainer from './SectionOptionsContainer'
import ColorButton from '../../../common/ColorButton'
import Icon from 'common/components/Icon';

// block drag events so these buttons can be used while placing a block
const blockDragEvents = {
  onMouseDown: e => e.stopPropagation()
}

export const SectionOptions = ({
  sectionNumber,
  sectionColor,
  sectionCount,
  createSection,
  moveSection,
  editSectionColor,
  deleteSection,
  duplicateSection,
  t,
  innerRef,
  outOfBoundaries,
  style
}) => {
  const canMoveUp = sectionNumber > 0
  const canMoveDown = sectionNumber + 1 < sectionCount
  return (
    <Menu
      {...blockDragEvents}
      outOfBoundaries={outOfBoundaries}
      innerRef={innerRef}
      style={style}
    >
      <ColorButton
        color={sectionColor}
        onChange={color => editSectionColor(color)}
      >
        {({ ref, toggle }) => (
          <Button innerRef={ref} onClick={toggle}>
            <Text>{t('section.backgroundColor')}</Text>
            <FormElement.Spacer />
            <FormElement.Swatch color={sectionColor} />
          </Button>
        )}
      </ColorButton>

      <Menu.Divider />

      <Button
        onClick={() => canMoveUp && moveSection(sectionNumber - 1)}
        stretch
        inactive={!canMoveUp}
      >
        {t('section.moveUp')}
      </Button>
      <Button
        onClick={() => canMoveDown && moveSection(sectionNumber + 1)}
        stretch
        inactive={!canMoveDown}
      >
        {t('section.moveDown')}
      </Button>

      <Menu.Divider />

      <Button onClick={() => duplicateSection()}>
        {t('section.duplicate')}
      </Button>

      <Menu.Divider />

      <Button
        onClick={() => sectionCount > 1 && deleteSection()}
        inactive={sectionCount === 1}
      >
        {t('section.delete')}
      </Button>

      <Menu.Divider />

      <Button onClick={() => createSection(sectionNumber)}>
        <Icon icon="plus" />
        <Text>{t('section.add.above')}</Text>
      </Button>

      <Button onClick={() => createSection(sectionNumber + 1)}>
        <Icon icon="plus" />
        <Text>{t('section.add.below')}</Text>
      </Button>
    </Menu>
  )
}

SectionOptions.propTypes = {
  sectionNumber: PropTypes.number.isRequired,
  sectionCount: PropTypes.number.isRequired,
  moveSection: PropTypes.func.isRequired,
  deleteSection: PropTypes.func.isRequired,
  duplicateSection: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default SectionOptionsContainer(SectionOptions)
